export const selectSectionStatusData = (state) => state.proposals.sectionStatus.data;
export const selectSectionStatusLoading = (state) => state.proposals.sectionStatus.isLoading;
export const selectSectionStatusError = (state) => state.proposals.sectionStatus.error;
